import { useState, useRef } from 'react';
import ButtonPrimary from "@base/Button"
import { Divider, Grid } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Table from '@base/Table'
import TextField from '@base/Inputs/Text';
import Subtitle from '@base/Subtitle';
import { useHistory } from 'react-router-dom'
import SearchIcon from "@material-ui/icons/Search";
import ListAltIcon from '@material-ui/icons/ListAlt';
import LabelIntruso from '@base/LabelIntruso';
import AuthorizedElement from '@security/AuthorizedElement';
import AplicarLegenda from '@base/AplicarLegenda';
import IncluirEscolaDialog from './IncluirEscolaDialog';
import HistoricoCaixasDialog from './HistoricoCaixasDialog';
import Toast from '@base/Toast';

import { IconButton, Box } from '@material-ui/core';

export const InformacaoObjetoPostal = ({ objeto, processo }) => {
  const history = useHistory();
  const toastRef = useRef(null);
  const [objetoPostal, setObjetoPostal] = useState(objeto ? objeto : {});
  const [openModalInclusaoEscola, setOpenModalInclusaoEscola] = useState(false);
  const [openModalHistoricoCaixa, setOpenModalHistoricoCaixa] = useState(false);

  const [desDigitalizacao,] = useState(objetoPostal.des.length);
  const [cartoesN1Digitalizacao,] = useState(objetoPostal.cartoesN1Recebidos);
  const [cartoesN2Digitalizacao,] = useState(objetoPostal.cartoesN2Recebidos);
  const [cartoesN3Digitalizacao,] = useState(objetoPostal.cartoesN3Recebidos);

  const [desContados,] = useState(objetoPostal.desContados);
  const [cartoesN1Contados,] = useState(objetoPostal.cartoesN1Contados);
  const [cartoesN2Contados,] = useState(objetoPostal.cartoesN2Contados);
  const [cartoesN3Contados,] = useState(objetoPostal.cartoesN3Contados);



  const columns = [
    { label: 'Codigo', name: 'codigoInep', func: null, key: true },
    {
      label: 'Nome', name: 'nome', func: (c, escola) => <>{c} {(objetoPostal.escolaDoObjetoPostal !== null && escola.codigoInep !== objetoPostal.escolaDoObjetoPostal.codigoInep ?
        <><LabelIntruso label={escola.enviouMaterialPeloEticketOriginal ? `Intruso - Objeto: ${escola.objetoPostalEticket}` : "Intruso"} />
        </> :
        <></>)}</>, key: false
    },
    { label: 'Telefone', name: 'telefone', func: null, key: false },
    { label: 'Alunos Previstos', name: 'alunosPrevistos', func: (c, l) => <AplicarLegenda n1={l.qtdAlunosN1Previsto} n2={l.qtdAlunosN2Previsto} n3={l.qtdAlunosN3Previsto} />, key: false },

  ];

  return (
    <>
      <Grid container style={{ margin: '24px 8px' }}>

        <Grid item lg={6}>
          <Grid item lg={12}>
            <Subtitle style={{ fontWeight: '600' }}>Informações Gerais</Subtitle>
          </Grid>
          <Grid container spacing={3}>
            <Grid item sm={4} lg={4}>
              <TextField
                label='Data da Postagem'
                value={objetoPostal.dataPostagem ?? '--'}
                readOnly={true}
              />
            </Grid>

            <Grid item sm={4} lg={4}>
              <TextField
                label='Peso(g)'
                value={objetoPostal.peso ?? '--'}
                readOnly={true}
              />
            </Grid>
          </Grid>

          <Grid item container spacing={3}>
            <Grid item sm={4} lg={4}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                <TextField
                  label="Caixa"
                  value={objetoPostal.caixa ?? '--'}
                  InputProps={{ readOnly: true }}
                  fullWidth
                />

                <IconButton
                  onClick={() => setOpenModalHistoricoCaixa(true)}
                  color="primary"
                  title={'Ver Histórico de Caixas do Objeto Postal.'}
                >
                  <ListAltIcon />
                </IconButton>

              </Box>
            </Grid>

            <Grid item sm={4} lg={4}>
              <TextField
                label='Posição na Caixa'
                value={objetoPostal.posicaoNaCaixa ?? '--'}
                readOnly={true}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={3}>
            <Grid item sm={4} lg={4}>
              <TextField
                label='Data do Recebimento'
                value={objetoPostal.dataRecebimento ?? '--'}
                readOnly={true}
              />
            </Grid>


            <Grid item sm={7} lg={7}>
              <TextField
                label='Responsável'
                value={objetoPostal.responsavelPortaria ?? '--'}
                readOnly={true}
              />
            </Grid>
          </Grid>

          <Grid item container spacing={3}>
            <Grid item sm={4} lg={4}>
              <TextField
                label='Data da Triagem'
                value={objetoPostal.dataTriagem ?? '--'}
                readOnly={true}
              />
            </Grid>
            <Grid item sm={7} lg={7}>
              <TextField
                label='Responsável'
                value={objetoPostal.responsavelTriagem ?? '--'}
                readOnly={true}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={3}>

            <Grid item sm={4} lg={4}>
              <TextField
                label='Data da Contagem'
                value={objetoPostal.dataContagem ?? '--'}
                readOnly={true}
              />
            </Grid>
            <Grid item sm={7} lg={7}>
              <TextField
                label='Responsável'
                value={objetoPostal.responsavelContagem ?? '--'}
                readOnly={true}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={3}>
            <Grid item sm={4} lg={4}>
              <TextField
                label='Data da Digitalização'
                value={objetoPostal.dataDigitalizacao ?? '--'}
                readOnly={true}
              />
            </Grid>
            <Grid item sm={4} lg={4}>
              <TextField
                label='Responsável'
                value={objetoPostal.responsavelDigitalizacao ?? '--'}
                readOnly={true}
              />
            </Grid>
            <Grid item sm={3} lg={3}>
              <TextField
                label='Estação'
                value={objetoPostal.estacaoDigitalizacao ?? '--'}
                readOnly={true}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={3}>
            <Grid item sm={4} lg={4}>
              <TextField
                label='Data do Armazenamento'
                value={objetoPostal.dataArmazenamento ?? '--'}
                readOnly={true}
              />
            </Grid>
            <Grid item sm={7} lg={7}>
              <TextField
                label='Responsável'
                value={objetoPostal.responsavelArmazenamento ?? '--'}
                readOnly={true}
              />
            </Grid>
          </Grid>

          {objetoPostal.caixa == null &&
            <Grid item container spacing={3}>
              <Grid item sm={12} lg={12}>
                <TextField
                  label='Anotação de Armazenamento'
                  value={objetoPostal.anotacaoArmazenamentoIndevido ?? '--'}
                  readOnly={true}
                />
              </Grid>
            </Grid>
          }
        </Grid>

        <Grid item lg={6}>
          <Subtitle style={{ fontWeight: '600' }}>Escolas</Subtitle>

          {objetoPostal?.escolas?.length > 0 && <Table
            columns={columns}
            tableData={objetoPostal.escolas}
            actions={[
              {
                name: () => "Visão Geral da Escola",
                func: (c, escola) => history.push(`/${processo.id}/escola/${escola.codigoInep}`),
                icon: <SearchIcon />,
                disabled: () => false,
              },
            ]}
            page={null}
            rowsPerPage={null}
            loading={false}
          />}


          <AuthorizedElement roles={["__processo.usuario.administrador"]} >
            {objetoPostal?.escolas?.length === 0 &&
              <ButtonPrimary
                onClick={() => setOpenModalInclusaoEscola(true)}
                name="Associar Escola"
              />}
          </AuthorizedElement>
        </Grid>


        {openModalInclusaoEscola &&
          <IncluirEscolaDialog
            processo={processo}
            numeroObjetoPostal={objetoPostal.numeroObjetoPostal}
            aoFechar={() => setOpenModalInclusaoEscola(false)}
            aoSalvar={(objetoPostal) => {
              setObjetoPostal(objetoPostal);
              setOpenModalInclusaoEscola(false);
            }}
            aberto={openModalInclusaoEscola} />
        }

        {openModalHistoricoCaixa &&
          <HistoricoCaixasDialog
            processo={processo}
            objetoPostal={objetoPostal}
            aoFechar={() => setOpenModalHistoricoCaixa(false)}
            aberto={openModalHistoricoCaixa} />
        }

      </Grid>
      <Divider />

      <Grid container style={{ margin: '24px 8px' }}>
        <Toast ref={toastRef} />
        <Subtitle style={{ fontWeight: '600' }}>Contagem</Subtitle>

        <Grid container spacing={3} alignItems='center'>
          <Grid item sm={6} lg={1}>
            <TextField
              label='DE'
              value={desContados}
            />
          </Grid>
          <Grid item sm={6} lg={1}>
            <TextField
              label='N1'
              value={cartoesN1Contados ?? '--'}
            />
          </Grid>
          <Grid item sm={6} lg={1}>
            <TextField
              label='N2'
              value={cartoesN2Contados ?? '--'}
            />
          </Grid>
          <Grid item sm={6} lg={1}>
            <TextField
              label='N3'
              value={cartoesN3Contados ?? '--'}
            />
          </Grid>

          <Grid item sm={12} lg={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={objetoPostal.conteudoNaoPrevisto}
                  value={objetoPostal.conteudoNaoPrevisto}
                  color='primary'
                />
              }
              label='Outros Documentos'
              readOnly={true}
            />
          </Grid>
        </Grid>
      </Grid>

      <Divider />

      <Grid container style={{ margin: '24px 8px' }}>
        <Subtitle style={{ fontWeight: '600' }}>Digitalização</Subtitle>
        <Grid container spacing={3} alignItems='center'>
          <Grid item sm={6} lg={1}>
            <TextField
              label='DEs'
              value={desDigitalizacao}
            />
          </Grid>
          <Grid item sm={6} lg={1}>
            <TextField
              label='N1'
              value={cartoesN1Digitalizacao}
              readOnly={true}
            />
          </Grid>
          <Grid item sm={6} lg={1}>
            <TextField
              label='N2'
              value={cartoesN2Digitalizacao}
            />
          </Grid>
          <Grid item sm={6} lg={1}>
            <TextField
              label='N3'
              value={cartoesN3Digitalizacao}
            />
          </Grid>

        </Grid>
      </Grid>

    </>
  );
}

export default InformacaoObjetoPostal;
